<template>
  <TemplatePageLayout>
    <template v-if="!this.$route.params.temp_id">
      <div class="template-listing__heading">
        <AppHeading tag="h2" text="Plantillas" />
        <AppCounter :total="templates.length" />
      </div>
      <div class="template-listing__actions">
        <SearchBar label="Búsqueda por título" v-model="searchQuery" />
        <AppButtonMagenta v-allowed.editor @click="openDIYModal(diyModalOptions)">
          <AppIcon icon="fas fa-layer-plus" />
          Nueva plantilla
        </AppButtonMagenta>
      </div>
      <!-- table -->
      <DataTable v-if="templates" :headers="tableConfig" :items="filterElements">
        <template #table-item="{ currentRow, currentOption }">
          <!-- TITLE -->
          <span v-if="currentOption.value === 'title'">
            {{ currentRow[currentOption.value] }}
          </span>
          <!-- STATUS -->
          <TemplatesTemplateStatus
            v-else-if="currentOption.value === 'status'"
            :status="currentRow[currentOption.value]"
          >
            {{ currentRow[currentOption.value] }}
          </TemplatesTemplateStatus>
          <!-- EDITORS -->
          <template v-else-if="currentOption.value === 'editors'">
            <CardUsers
              v-if="hasEditors(currentRow.translations[currentOption.value])"
              :users="currentRow.translations[currentOption.value]"
            />
            <span v-else>Sin editor</span>
          </template>
          <!-- ES TRANSLATION -->
          <template v-else-if="currentOption.value === 'es'">
            <TemplatesLanguageControl :template="currentRow" :language-code="currentOption.value" />
          </template>
          <!-- ENG TRANSLATION -->
          <template v-else-if="currentOption.value === 'en'">
            <TemplatesLanguageControl :template="currentRow" :language-code="currentOption.value" />
          </template>
          <!-- DEFAULT -->
          <span v-else :class="`row-${currentOption.value}`">
            {{ currentRow[currentOption.value] }}
          </span>
        </template>
        <!-- NOT FOUND -->
        <template #table-add-ons>
          <transition name="scale-in">
            <SearchNoResults v-if="noElementsFound" :query="searchQuery" />
          </transition>
        </template>
      </DataTable>
    </template>
    <!-- template single page -->
    <router-view v-if="this.$route.params.temp_id"></router-view>
  </TemplatePageLayout>
</template>

<script>
// Utitlities
import DIYModalControl from 'Mixins/DIYModalControl'
import { checkArray, filterElementsByQuery } from 'Utils'
import { loadTemplates } from 'Router/middleware/templates-load'
// Components
import AppIcon from 'Ui/AppIcon'
import SearchBar from 'Ui/SearchBar'
import AppCounter from 'Ui/AppCounter'
import AppHeading from 'Ui/AppHeading'
import DataTable from 'Components/DataTable'
import CardUsers from 'Components/CardUsers'
import AppButtonMagenta from 'Ui/AppButtonMagenta'
import SearchNoResults from 'Components/SearchNoResults'
import TemplatePageLayout from 'Layouts/TemplatePageLayout'
import TemplatesLanguageControl from 'Modules/Templates/components/TemplatesLanguageControl'
import TemplatesTemplateStatus from 'Modules/Templates/components/TemplatesTemplateStatus'

export default {
  name: 'TemplatesListingPage',

  components: {
    AppIcon,
    SearchBar,
    DataTable,
    CardUsers,
    AppHeading,
    AppCounter,
    SearchNoResults,
    AppButtonMagenta,
    TemplatePageLayout,
    TemplatesLanguageControl,
    TemplatesTemplateStatus,
  },

  data() {
    return {
      showModal: false,
      templates: [],
      searchQuery: '',
      diyModalOptions: {
        title: 'Nueva Plantilla',
        component: 'NewTemplateForm',
        icon: 'fal fa-pencil-ruler',
      },

      tableConfig: [
        { text: 'Título', value: 'title', sortable: true },
        { text: 'Categoría', value: 'category', sortable: true },
        // { text: 'Status', value: 'status', sortable: true },
        { text: 'Editores', value: 'editors', sortable: false },
        // { text: 'Creado', value: 'created_formated', sortable: true },
        // { text: 'Modificado', value: 'modified_formated', sortable: true },
        { text: 'ES', value: 'es', sortable: true, sortablePath: ['translations', 'es', 'status'] },
        { text: 'EN', value: 'en', sortable: true, sortablePath: ['translations', 'en', 'status'] },
      ],
    }
  },

  mixins: [DIYModalControl],

  methods: {
    setTemplates() {
      this.templates = this.$store.state.templates.templates
    },

    setActiveOption(option) {
      this.activeOption = this.options[this.options.indexOf(option)]
    },
  },

  computed: {
    // limitedItems() {
    //   return this.templates.slice(
    //     this.currentPage * this.activeOption.value,
    //     this.currentPage * this.activeOption.value + this.activeOption.value
    //   )
    // },
    // sortedTemplates() {
    //   return sortArrayByObjectKey(this.templates, 'modified', true)
    // },

    filterElements() {
      return filterElementsByQuery(this.searchQuery, this.templates, 'title')
    },

    hasEditors() {
      return (array) => checkArray(array)
    },

    noElementsFound() {
      return this.filterElements.length <= 0
    },
  },

  mounted() {
    this.setTemplates()
  },

  async beforeRouteUpdate(to, from, next) {
    if (to.name !== 'templates-listing') return next()
    await loadTemplates(next)
    this.setTemplates()
    next()
  },
}
</script>

<style scoped>
.template-listing__heading {
  display: flex;
  gap: 10px;
  align-items: center;
}

.template-listing__heading .app-heading {
  font-weight: 900;
}

.template-listing__actions {
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  grid-gap: 20px;
  margin: 20px 0;
}

.template-listing__actions .search-bar >>> label {
  top: 12px;
  left: 8px;
  pointer-events: none;
}

.template-listing__actions .app-button {
  min-width: 150px;
}

.template-listing__actions .app-button .app-icon {
  color: #fff;
  margin-right: 10px;
}

.data-table >>> .row-status {
  font-size: 12px;
}

@media (max-width: 580px) {
  .template-listing__actions {
    grid-template-columns: 1fr;
  }
}
</style>
